export function capitalize(value: string) {
  let capitalizedText = "";
  const conjunctions = [
    "an",
    "a",
    "the",
    "of",
    "and",
    "but",
    "for",
    "nor",
    "or",
    "so",
    "yet",
    "in",
    "on",
    "at",
    "to",
    "by",
    "with",
  ];

  const textArray = value?.split(" ");

  for (let i = 0; i < textArray?.length; i++) {
    const word = textArray[i];
    if (i === 0 || word?.endsWith(".")) {
      capitalizedText +=
        word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase() + " ";
    } else if (conjunctions?.includes(word?.toLowerCase())) {
      capitalizedText += word?.toLowerCase() + " ";
    } else {
      capitalizedText +=
        word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase() + " ";
    }
  }

  return capitalizedText?.trim();
}

export const firstChar = (
  text?: string,
  textCase: "UPPER" | "LOWER" | "DEFAULT" = "UPPER"
) => {
  if (text) {
    const txt = text?.charAt(0);

    switch (textCase) {
      case "UPPER":
        return txt.toUpperCase();
      case "LOWER":
        return txt.toLowerCase();
      default:
        return txt;
    }
  }

  return "";
};

export const normalizePhoneNumber = (phone: string): string => {
  if (!phone) return phone;

  const trimmed = phone.trim();

  if (trimmed.startsWith("+88")) {
    return trimmed;
  }

  if (trimmed.startsWith("88")) {
    return `+${trimmed}`;
  }

  return `+88${trimmed}`;
};

export const isActivePath = (position: number, key: string) => {
  const pathArr = window.location.pathname.split("/").filter((str) => str);
  return pathArr[position] === key;
};

export const selectSearchOption = (
  input: string,
  option?: { label: string; value: string | number | boolean }
) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

export const removeEmpty = (arr: any[] = []) => {
  return arr.filter((el) => el);
};

export const stringToArray = (text: string, splitText: string = " ") => {
  return removeEmpty(text?.split(splitText));
};

export const getExtension = (url: string) => {
  const file = stringToArray(url, ".") as string[];
  return file?.[file?.length - 1]?.toLowerCase();
};
